import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import * as actions from '../../actions'
import { PedidoEgreso0 } from './steps'
import { FORM_PEDIDO_EGRESO } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'
import TablaPedidoCamionesEnPlaya from './pedidoCamionesEnPlaya/containers/TablaPedidoCamionesEnPlaya'
import SwitchCorteCereal from '../../components/pedidosEgresoPlaya/SwitchCorteCereal'

class PedidoEgresoPlaya extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount () {
    this.props.getCortesPedidos()
  }

  handleSubmit () {
    this.props.pedidoEgresoPlayaCpa(this.props.destroy)
  }

  render () {
    const { cortesPedidos } = this.props
    return (
      <div className='camiones-abandono-container'>
        <h2>Solicitud de Camiones en Playa</h2>
        <hr />
        <PedidoEgreso0 onSubmit={this.handleSubmit} />
        <hr />
        <TablaPedidoCamionesEnPlaya />
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <div className='container-corte-cereales-calado'>
          <h2>Corte de productos</h2>
          <hr />
          <SwitchCorteCereal cortesPedidos={cortesPedidos} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    cortesPedidos: state.camionesIngreso.cortesPedidos
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({ form: FORM_PEDIDO_EGRESO })(PedidoEgresoPlaya)
)
